import { Directive, OnDestroy } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { takeUntil, tap } from 'rxjs/operators';
import { BehaviorSubject, filter, Subject } from 'rxjs';

/** Абстрактный класс, проверяет корректность параметра page и записывает query параметры из url */
@Directive()
export abstract class QueryParamsUrl implements OnDestroy {
  protected constructor(public router: Router, public route: ActivatedRoute) {
    this.handlerQueryParamsUrl();
  }

  private _queryParams$ = new BehaviorSubject<Params | null>(null);

  /**
   * Непустые параметры запроса из адресной строки.
   *
   * NB: у нас на сайте параметры адресной строки и их значения в lower case
   */
  queryParams$ = this._queryParams$.pipe(
    filter((params: Params | null): params is Params => !!params)
  );
  ngUnsubscribe$ = new Subject<void>();

  private handlerQueryParamsUrl(): void {
    this.route.queryParams
      .pipe(
        tap((params: Params): void => {
          const page: unknown = params.page;
          const pageNumber = Number(page);

          if (page === undefined || page === null || pageNumber > 0) {
            this._queryParams$.next(params);
          } else {
            this.setQueryParamsUrl(null);
          }
        }),
        takeUntil(this.ngUnsubscribe$)
      )
      .subscribe();
  }

  /**
   * Устанавливает значения параметров запроса в адресной строке.
   *
   * NB: у нас на сайте параметры адресной строки и их значения в lower case
   * @param value Объект с параметры адресной строки и их новыми значениями.
   */
  setQueryParamsUrl(value: Record<string, unknown> | null): void {
    this.router.navigate([], {
      queryParams: { page: null, ...value },
      queryParamsHandling: 'merge',
    });
  }

  /** Сбрасывает все параметры запроса в адресной строке. */
  resetQueryParamsUrl(): void {
    this.router.navigate([], { queryParams: null });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
